import CopyHtml  from "../components/copyhtml";

function Email() {
    return (
        <CopyHtml>

            <table border={0} align="center" cellPadding={0} cellSpacing={0} width="100%">



                <tbody>
                    {/* BODY CONTENT */}
                    <tr>
                        <td align="center" style={{ padding: 20 }}>


                            {/* Page 1 */}
                            <table
                                align="center"
                                border={0}
                                cellPadding={0}
                                cellSpacing={0}
                                style={{ minWidth: "100px", maxWidth: "600px", border: "solid 1px #dddddd", backgroundColor: "#ffffff", boxShadow: "0 0 15px rgba(0, 0, 0, 0.5)" }}
                            >
                                <tbody>
                                    <tr>
                                        <td align="center" style={{ padding: "0 20px 20px" }}>
                                            <table width="100%" cellPadding={0} cellSpacing={0} border={0}>
                                                {/* Dear Program Director */}
                                                <tbody>
                                                    <tr className="stack-column">
                                                        <td
                                                            width="33.33%"
                                                            align="center"
                                                            className="stack-column"
                                                            style={{ padding: 10 }}
                                                        >
                                                            <h4>Dear program director</h4>
                                                            <p>
                                                                In late 2025, or anytime in 2026 you have opportunity
                                                                to have a great ventriloquist show at your facility.
                                                                Using our own American holidays and history to be a
                                                                vehicle to reinforce so many of our heart felt
                                                                memories. That coming to you from a bunch of funny
                                                                wholesome, talkative puppets, who are dressed for the
                                                                occasion. Loads of jokes. portions of great seasonal
                                                                and noteworthy songs mixed in with your all-time
                                                                favorites.
                                                            </p>
                                                        </td>
                                                        <td
                                                            width="33.33%"
                                                            align="center"
                                                            className="stack-column"
                                                            style={{ padding: 10 }}
                                                        >
                                                            <a href="https://www.fishervent.com/assets/img/rogerandtanners.jpg">
                                                                <img
                                                                    src="https://www.fishervent.com/assets/img/rogerandtanners.jpg"
                                                                    alt="Roger and Tanners"
                                                                    title="Roger and Tanners"
                                                                    width="100%"
                                                                />
                                                            </a>
                                                        </td>
                                                    </tr>
                                                    {/* Grown Up Christmas List */}
                                                    <tr className="stack-column">
                                                        <td
                                                            width="33.33%"
                                                            align="center"
                                                            className="stack-column"
                                                            style={{ padding: 10 }}
                                                        >
                                                            <a href="http://www.fishervent.com/videos#grownUpChristmasList">
                                                                <img src="https://www.fishervent.com/assets/img/tannersGrownUpChristmas.png" alt="Roger Fisher & Tanners" title="Roger in dentist gown with Tanner dog and Tanner puppet" width="100%" />
                                                            </a>
                                                        </td>
                                                        <td
                                                            width="33.33%"
                                                            align="center"
                                                            className="stack-column"
                                                            style={{ padding: 10 }}
                                                        >
                                                            <h4>
                                                                To see my latest{" "}
                                                                <a href="https://www.fishervent.com/videos#grownUpChristmasList">"My Grown Up Christmas List"</a> a live
                                                                song at the Crescent Moon Coffee Shop in Lincoln, NE.
                                                            </h4>
                                                            <h3>Click the arrow on the left to watch video on fishervent.com.</h3>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            {/* Single Paragraph Section */}
                                            <table width="100%" cellPadding={0} cellSpacing={0} border={0}>
                                                <tbody>
                                                    <tr className="stack-column">
                                                        <td width="33.33%" align="center" style={{ padding: 10 }}>
                                                            <p style={{ textIndent: 0 }}>
                                                                We have done shows in Methodist, Lutheran, and Berean
                                                                churches. Also we have done lots of senior shows in
                                                                assisted living, independent, memory care, group
                                                                homes, 55+, and governmental programs. Also, hundreds
                                                                of other different gigs in all venues.
                                                            </p>
                                                            <p style={{ textIndent: 0 }}>
                                                                After performing so many times, my friends and I have
                                                                put together two great shows!
                                                            </p>
                                                            <p
                                                                style={{
                                                                    width: "100%",
                                                                    textIndent: 0,
                                                                    textAlign: "center"
                                                                }}
                                                            >
                                                                You can sign up now or at fishervent.com!
                                                            </p>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>


                    {/* Page 2 */}
                    <tr>
                        <td
                            align="center"
                            style={{ paddingBottom: 20, paddingLeft: 20, paddingRight: 20 }}
                        >
                            <table
                                width={600}
                                align="center"
                                border={0}
                                cellPadding={0}
                                cellSpacing={0}
                                style={{ width: "100%", minWidth: "100px", maxWidth: "600px", border: "solid 1px #dddddd", backgroundColor: "#ffffff", boxShadow: "0 0 15px rgba(0, 0, 0, 0.5)" }}
                            >
                                <tbody>
                                    <tr>
                                        <td align="center" style={{ padding: "0 20px 20px" }}>
                                            <table width="100%" cellPadding={0} cellSpacing={0} border={0}>
                                                {/* American Adventure */}
                                                <tbody>
                                                    <tr className="stack-column">
                                                        <td
                                                            width="33.33%"
                                                            align="center"
                                                            className="stack-column"
                                                            style={{ padding: 10 }}
                                                        >
                                                            <a href="https://www.fishervent.com/assets/img/theamericanadventure.png">
                                                                <img
                                                                    src="https://www.fishervent.com/assets/img/theamericanadventure.png"
                                                                    alt="The American Adventure"
                                                                    title="The American Adventure"
                                                                    width="100%"
                                                                />
                                                            </a>
                                                            <h4>The American Adventure</h4>
                                                            <p>
                                                                A positive tribute of past and present adventures and
                                                                songs of our awesome America.
                                                            </p>
                                                        </td>
                                                        <td
                                                            width="33.33%"
                                                            align="center"
                                                            className="stack-column"
                                                            style={{ padding: 10 }}
                                                        >
                                                            <a href="https://www.fishervent.com/videos#liveShowMP4">
                                                                <img src="https://www.fishervent.com/assets/img/convention/liveShowImg.png" alt="Live Show" title="Live Show" width="100%" />
                                                            </a>
                                                            <p style={{ width: "100%", textAlign: "center" }}>
                                                                Click on above image to watch video on fishervent.com
                                                            </p>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>


                    {/* Page 3 */}
                    <tr>
                        <td
                            align="center"
                            style={{ paddingBottom: 20, paddingLeft: 20, paddingRight: 20 }}
                        >
                            <table
                                width={600}
                                align="center"
                                border={0}
                                cellPadding={0}
                                cellSpacing={0}
                                style={{ width: "100%", minWidth: "100px", maxWidth: "600px", border: "solid 1px #dddddd", backgroundColor: "#ffffff", boxShadow: "0 0 15px rgba(0, 0, 0, 0.5)" }}
                            >
                                <tbody>
                                    <tr>
                                        <td align="center" style={{ padding: "0 20px 20px" }}>
                                            <table width="100%" cellPadding={0} cellSpacing={0} border={0}>
                                                {/* Holidays in the USA */}
                                                <tbody>
                                                    <tr className="stack-column">
                                                        <td
                                                            width="33.33%"
                                                            align="center"
                                                            className="stack-column"
                                                            style={{ padding: 10 }}
                                                        >
                                                            <a href="https://www.fishervent.com/assets/img/holidaysintheusa.png">
                                                                <img
                                                                    src="https://www.fishervent.com/assets/img/holidaysintheusa.png"
                                                                    alt="Holidays in the USA"
                                                                    title="Holidays in the USA"
                                                                    width="100%"
                                                                />
                                                            </a>
                                                            <h4>Holidays in the USA</h4>
                                                            <p>
                                                                A smattering of my past seven holiday shows on YouTube
                                                                the past four years. It comes with some new pizzazz
                                                                and highlighting of our holiday themes that are so
                                                                fun, so captivating!
                                                            </p>
                                                        </td>
                                                        {/* Family Easter Week Video */}
                                                        <td
                                                            width="33.33%"
                                                            align="center"
                                                            className="stack-column"
                                                            style={{ padding: 10 }}
                                                        >
                                                            <a href="https://www.fishervent.com/videos#easter2023">
                                                                <img src="https://www.fishervent.com/assets/img/familyEasterWeek.png" alt="Family Easter Week" title="Family Easter Week Live" width="100%" />
                                                            </a>
                                                            <p style={{ textAlign: "center", margin: "1rem" }}>
                                                                Click the above arrow to watch the video on fishervent.com.
                                                            </p>
                                                            <p>
                                                                One of the shows of the YouTube series Holidays in the
                                                                USA is the ”Family Easter Week”. This show was a viral
                                                                hit with over 80 thousand hits in one week and YouTube
                                                                made it seen to over 1.4 million times worldwide.
                                                            </p>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>


                    {/* Page 4 */}
                    <tr>
                        <td
                            align="center"
                            style={{ paddingBottom: 20, paddingLeft: 20, paddingRight: 20 }}
                        >
                            <table
                                width={600}
                                align="center"
                                border={0}
                                cellPadding={0}
                                cellSpacing={0}
                                style={{ width: "100%", minWidth: "100px", maxWidth: "600px", border: "solid 1px #dddddd", backgroundColor: "#ffffff", boxShadow: "0 0 15px rgba(0, 0, 0, 0.5)" }}
                            >
                                <tbody>
                                    <tr>
                                        <td align="center" style={{ padding: "0 20px 20px" }}>
                                            <table width="100%" cellPadding={0} cellSpacing={0} border={0}>
                                                {/* Dentist */}
                                                <tbody>
                                                    <tr className="stack-column">
                                                        <td
                                                            width="33.33%"
                                                            align="center"
                                                            className="stack-column"
                                                            style={{ padding: 10 }}
                                                        >
                                                            <a href="https://www.fishervent.com/assets/img/aboutmyself.png">
                                                                <img
                                                                    src="https://www.fishervent.com/assets/img/aboutmyself.png"
                                                                    alt="About Myself Image"
                                                                    title="About Myself"
                                                                    width="100%"
                                                                />
                                                            </a>
                                                        </td>
                                                        <td
                                                            width="33.33%"
                                                            align="center"
                                                            className="stack-column"
                                                            style={{ padding: 10 }}
                                                        >
                                                            <p>
                                                                Before venturing into ventriloquism, I have been a
                                                                Dentist for over 36 years. Starting my career as a
                                                                teacher, then becoming a tennis professional
                                                                instructor. During my collegiate career, I was a
                                                                national counselor for the Fellowship of Christian
                                                                Athletes. As a tennis pro of the Lincoln Racket Club I
                                                                organized free clinics to kids to learn about Christ
                                                                and playing tennis.
                                                            </p>
                                                        </td>
                                                    </tr>
                                                    {/* Hospital Visit */}
                                                    <tr className="stack-column">
                                                        <td
                                                            width="33.33%"
                                                            align="center"
                                                            className="stack-column"
                                                            style={{ padding: 10 }}
                                                        >
                                                            <p style={{ textIndent: 0 }}>
                                                                Over a 13 year period I devoted time for persons with
                                                                needed dental/medical care, playing a very active roll
                                                                and building a $300k state of the art free dental
                                                                clinic. The governor of Nebraska even acknowledged me
                                                                with the Point of Light award, a unique statewide
                                                                recognition of service to others.
                                                            </p>
                                                            <p>
                                                                I have even traveled to Honduras on a dental mission.
                                                                I currently live in Lincoln, Nebraska on a lake just
                                                                west of the University of Nebraska Cornhusker campus
                                                                and stadium. I live with a live golden doodle dog who
                                                                is often a part of the show.
                                                            </p>
                                                        </td>
                                                        <td
                                                            width="33.33%"
                                                            align="center"
                                                            className="stack-column"
                                                            style={{ padding: 10 }}
                                                        >
                                                            <a href="https://www.fishervent.com/assets/img/hospitalvisit.jpeg">
                                                                <img
                                                                    src="https://www.fishervent.com/assets/img/hospitalvisit.jpeg"
                                                                    alt="Hospital Visit"
                                                                    title="Hospital Visit"
                                                                    width="100%"
                                                                />
                                                            </a>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>

                    {/* Page 5 */}
                    <tr>
                        <td align="center" style={{ paddingBottom: '20px', paddingLeft: '20px', paddingRight: '20px' }}>
                            <table
                                width={600}
                                align="center"
                                border={0}
                                cellPadding={0}
                                cellSpacing={0}
                                style={{ width: "100%", minWidth: "100px", maxWidth: "600px", border: "solid 1px #dddddd", backgroundColor: "#ffffff", boxShadow: "0 0 15px rgba(0, 0, 0, 0.5)" }}
                            >                          <tr>
                                    <td align="center" style={{ padding: '0 20px 20px' }}>
                                        <table width="100%" cellPadding={0} cellSpacing={0} border={0}>
                                            {/* Single Paragraph Section */}
                                            <tr className="stack-column">


                                                <td width="100%" align="center" className="stack-column" style={{ padding: '10px' }}>
                                                    <p style={{ textIndent: '10px' }}>
                                                        Performing over 150 gigs with over 7000 miles of travel.
                                                        Ranging from Yellowstone National Park to Seattle to San Francisco to Lake Tahoe to
                                                        Rocky Mountain national Park in Colorado on the national Western tour.
                                                        Touring the Southwest from Albuquerque, New Mexico to Phoenix, Arizona.
                                                        Touching base from Niagara Falls to New Harbor Maine. Doing a lot in my home
                                                        state of Nebraska and shows in Orlando, Florida.
                                                    </p>
                                                </td>
                                            </tr>
                                        </table>

                                        <table width="100%" cellPadding={0} cellSpacing={0} border={0}>
                                            {/* National Ventriloquist Convention */}
                                            <tr className="stack-column">
                                                <td width="33.33%" align="center" className="stack-column" style={{ padding: '10px' }}>
                                                    <p>
                                                        One of my highlights so far was to be picked as a medalist being one of the final
                                                        eight to perform in the open mic competition of the National Ventriloquist Convention,
                                                        especially, using the same mic as Jeff Dunham.
                                                    </p>
                                                </td>
                                                <td width="33.33%" align="center" className="stack-column" style={{ padding: '10px' }}>
                                                    <a href="https://www.fishervent.com/videos#ventConventMP4">
                                                        <img src="https://www.fishervent.com/assets/img/convention/rogertannergeneral.jpg" alt="VentHaven Convention" title="VentHaven Convention" width="100%" />
                                                    </a>
                                                    <p style={{ width: "100%", textAlign: "center" }}>
                                                        Click on above image to watch video on fishervent.com
                                                    </p>


                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>

                    {/* Page 6 */}
                    <tr>
                        <td align="center" style={{ paddingBottom: '20px', paddingLeft: '20px', paddingRight: '20px' }}>
                            <table
                                width={600}
                                align="center"
                                border={0}
                                cellPadding={0}
                                cellSpacing={0}
                                style={{ width: "100%", minWidth: "100px", maxWidth: "600px", border: "solid 1px #dddddd", backgroundColor: "#ffffff", boxShadow: "0 0 15px rgba(0, 0, 0, 0.5)" }}
                            >                         <tr>
                                    <td align="center" style={{ padding: '0 20px 20px' }}>
                                        <table width="100%" cellPadding={0} cellSpacing={0} border={0}>
                                            {/* Paragraph Section */}
                                            <tr className="stack-column">
                                                <td width="100%" align="center" className="stack-column" style={{ padding: '10px' }}>
                                                    <p style={{ textIndent: '0px' }}>
                                                        As far as payment, I am looking at the two shows for $800, or one show at $600.
                                                        “The American Adventure” is an hour show, and the “Holidays in the USA” is an hour and a half show.
                                                        If travel is involved a $100 travel fee. Any senior event is an hour & the customary fee.
                                                    </p>
                                                    <p>
                                                        I am negotiable because my goal is to uplift everyone, and have fun.
                                                        I can also come early to greet and invite members and meet kids. Certainly, this is a chance to invite Guests!
                                                    </p>
                                                    <p>
                                                        Our show is done in a general way and can be customized to your audience.
                                                        Often only portions of the songs are done and a program is available to follow the songs.
                                                    </p>
                                                    <p>
                                                        Other events we have done/are available to you include:
                                                        Birthday or office parties, service club or fundraising event, any senior event, family or school or community reunion or gathering.
                                                        Any function like hospital, or hospice event, a coffee shop, sports bar, nightclub or sports activity, a reception, carnival, or market show.
                                                        All kinds of school/church situations of any age. Of course, etc.etc which my puppets always can adapt to enhance your activity.
                                                    </p>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>

                    {/* Page 7 */}
                    <tr>
                        <td align="center" style={{ paddingBottom: '20px', paddingLeft: '20px', paddingRight: '20px' }}>
                            <table
                                width={600}
                                align="center"
                                border={0}
                                cellPadding={0}
                                cellSpacing={0}
                                style={{ width: "100%", minWidth: "100px", maxWidth: "600px", border: "solid 1px #dddddd", backgroundColor: "#ffffff", boxShadow: "0 0 15px rgba(0, 0, 0, 0.5)" }}
                            >                               <tr>
                                    <td align="center" style={{ padding: '0 20px 20px' }}>

                                        <table width="100%" cellPadding={0} cellSpacing={0} border={0}>
                                            {/* National Ventriloquist Convention */}
                                            <tr className="stack-column">
                                                <td width="50%" align="center" className="stack-column" style={{ padding: '10px' }}>
                                                    <img
                                                        src="https://www.fishervent.com/assets/img/theamericanadventure.png"
                                                        alt="Holidays in the USA"
                                                        title="Holidays in the USA"
                                                        width="50%"
                                                    />
                                                    <img src="https://www.fishervent.com/assets/img/adventureScript.png" alt="Adventures Script" title="Adventures Script" width="100%" />
                                                </td>
                                            </tr>
                                            <tr className="stack-column">
                                                <td width="50%" align="center" className="stack-column" style={{ padding: '10px' }}>
                                                    <img
                                                        src="https://www.fishervent.com/assets/img/holidaysintheusa.png"
                                                        alt="Holidays in the USA"
                                                        title="Holidays in the USA"
                                                        width="50%"
                                                    />
                                                    <img src="https://www.fishervent.com/assets/img/holidaysScript.png" alt="Holidays Script" title="Holidays Script" width="100%" />
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>


                    {/* Form Page */}
                    <tr>
                        <td align="center" style={{ paddingBottom: '20px', paddingLeft: '20px', paddingRight: '20px' }}>
                            <table
                                width={600}
                                align="center"
                                border={0}
                                cellPadding={0}
                                cellSpacing={0}
                                style={{ width: "100%", minWidth: "100px", maxWidth: "600px", border: "solid 1px #dddddd", backgroundColor: "#ffffff", boxShadow: "0 0 15px rgba(0, 0, 0, 0.5)" }}
                            >                                <tr>
                                    <td align="center" style={{ padding: '0 20px 20px' }}>

                                        <table width="100%" cellPadding={0} cellSpacing={0} border={0}>
                                            {/* National Ventriloquist Convention */}
                                            <tr className="contact-form">
                                                <h2>Contact Us</h2>
                                                <tr className="stack-column">
                                                    <td width="33%" align="left" className="stack-column" style={{ padding: '10px' }}>
                                                        <label htmlFor="name">Name *</label>
                                                        <input type="text" id="name" name="name" required="" />
                                                    </td>
                                                </tr>
                                                <tr className="stack-column">
                                                    <td width="33%" align="left" className="stack-column" style={{ padding: '10px' }}>
                                                        <label htmlFor="organization">Organization Name</label>
                                                        <input type="text" id="organization" name="organization" />
                                                    </td>
                                                </tr>
                                                <tr className="stack-column">
                                                    <td width="33%" align="left" className="stack-column" style={{ padding: '10px' }}>
                                                        <label htmlFor="email">Email *</label>
                                                        <input type="email" id="email" name="email" required="" />
                                                    </td>
                                                </tr>
                                                <tr className="stack-column">
                                                    <td width="33%" align="left" className="stack-column" style={{ padding: '10px' }}>
                                                        <label htmlFor="phone">Phone Number *</label>
                                                        <input type="tel" id="phone" name="phone" required="" />
                                                    </td>
                                                </tr>
                                                <tr className="stack-column">
                                                    <td width="33%" align="left" className="stack-column" style={{ padding: '10px' }}>
                                                        <label htmlFor="type">Type of Show *</label>
                                                        <select id="type" name="type" required="">
                                                            <option value="">-- Select --</option>
                                                            <option value="The American Adventure">The American Adventure</option>
                                                            <option value="Holidays in the USA">Holidays in the USA</option>
                                                            <option value="exhibition">Exhibition</option>
                                                            <option value="private_event">Private Event</option>
                                                            <option value="other">Other</option>
                                                        </select>
                                                    </td>
                                                </tr>
                                                <tr className="stack-column">
                                                    <td width="33%" align="left" className="stack-column" style={{ padding: '10px' }}>
                                                        <label htmlFor="date">Event Date *</label>
                                                        <input type="date" id="date" name="date" required="" />
                                                    </td>
                                                </tr>
                                                <tr className="stack-column">
                                                    <td width="33%" align="left" className="stack-column" style={{ padding: '10px' }}>
                                                        <label htmlFor="location">Event Location *</label>
                                                        <input type="text" id="location" name="location" required="" />
                                                    </td>
                                                </tr>
                                                <tr className="stack-column">
                                                    <td width="33%" align="left" className="stack-column" style={{ padding: '10px' }}>
                                                        <label htmlFor="message">Message *</label>
                                                        <textarea id="message" name="message" required="" defaultValue={""} />
                                                    </td>
                                                </tr>
                                                <tr className="stack-column">
                                                    <td width="33%" align="left" className="stack-column" style={{ padding: '10px' }}>
                                                        <a href="https://www.fishervent.com/contact#form">
                                                            <button type="submit">Fill out form on www.fishervent.com</button>
                                                        </a>
                                                    </td>
                                                </tr>

                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>


                </tbody>
            </table>
        </CopyHtml>
    )
}

export default Email;